import { render, staticRenderFns } from "./Ressuprimento.vue?vue&type=template&id=12940b31"
import script from "./Ressuprimento.vue?vue&type=script&lang=js"
export * from "./Ressuprimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports